





















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component<Header>({})
export default class Header extends Vue {
    @Prop()
    public brkPoints!: object;

    public goHome() {
        this.$router.push({ name: 'index' });
    }
}
